import { Helmet } from "react-helmet";

const TravelInsurance = () => {
    return(
      <>
      <Helmet>
        <title>Worldwide best travel insurance</title>
      </Helmet>
        <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
          {/* ================= Sticky section ================= */}
          <section>
            <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
              <h2 className="text-xl font-bold text-white text-center">
                Get Project Estimation
              </h2>
              <form className="mt-6 lg:mt-3">
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                  type="text"
                  placeholder="Name"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                  type="email"
                  placeholder="Email"
                />
                <input
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                  type="number"
                  placeholder="Phone number"
                />
                <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                  <option disabled="" selected="">
                    Select Budget
                  </option>
                  <option>USD 2000 - USD 5000</option>
                  <option>USD 5000 - USD 10000</option>
                  <option>USD 10000 - USD 20000</option>
                  <option>USD 20000 - USD 40000</option>
                  <option>USD 40000 - USD 60000</option>
                  <option>USD 60000 - USD 90000</option>
                  <option>USD 90000 - USD 130000</option>
                  <option>USD 130000 - USD 200000</option>
                  &gt;
                </select>
                <textarea
                  className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                  placeholder="message"
                  rows={3}
                  defaultValue={""}
                />
                <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                  Submit
                </button>
              </form>
            </div>
          </section>
          {/* ================== Main section ================= */}
          <section>
            {/* ================ Hero section ================= */}
            <section className="grid grid-cols-7 mt-12 gap-4 mb-20 lg:mb-32 items-center">
              <div className="col-span-7 lg:col-span-3">
                <img src="image/travel.jpg" alt="" />
                <p className="text-3xl mt-5 text-center font-bold">
                  Ensure a safe trip with Travel Insurance
                </p>
              </div>
              {/* 4 Card section  */}
              <div className="col-span-7 lg:col-span-4 lg:px-6">
                <h3 className="text-2xl font-bold">
                  Please select the purpose of your travel
                </h3>
                <div className="grid grid-cols-2 mt-4 gap-8">
                  <div className="bg-[#6cb8f76b] py-4 rounded-lg">
                    <img
                      className="w-14 mx-auto"
                      src="image/icon/business_holiday.svg"
                      alt=""
                    />
                    <p className="text-center my-2 text-xl font-bold">
                      Business/Holiday
                    </p>
                  </div>
                  <div className="bg-[#6cb8f76b] py-4 rounded-lg">
                    <img className="w-14 mx-auto" src="image/icon/study.svg" alt="" />
                    <p className="text-center my-2 text-xl font-bold">Study</p>
                  </div>
                  <div className="bg-[#6cb8f76b] py-4 rounded-lg">
                    <img className="w-14 mx-auto" src="image/icon/worker.svg" alt="" />
                    <p className="text-center my-2 text-xl font-bold">Employment</p>
                  </div>
                  <div className="bg-[#6cb8f76b] py-4 rounded-lg">
                    <img
                      className="w-14 mx-auto"
                      src="image/icon/frequent_traveling.svg"
                      alt=""
                    />
                    <p className="text-center my-2 text-xl font-bold">
                      Frequent Traveling
                    </p>
                  </div>
                </div>
              </div>
            </section>
            {/* ================== Text section ================= */}
            <section className="mt-32">
              <div className="text-lg font-medium text-gray-700 text-justify">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                  Travel Insurance in UAE
                </h2>
                <p className="my-6">
                  Find the best travel insurance deals in Dubai only at Insurance Cart.
                  Get your customized price quote and order online quickly using the
                  Insurance Cart website or mobile app. Secure yourself and your loved
                  ones while travelling abroad with travel insurance that provides
                  coverage against unexpected events and medical emergencies such as
                  accidental injuries, illness, death, etc.
                </p>
                <p>
                  Travel Insurance, more commonly known as Overseas Mediclaim Policy,
                  provides coverage for United Arab Emirates nationals visiting abroad;
                  for multiple purposes, including business, holidays, tours, studies,
                  employment, or temporary residency in foreign lands outside of Abu
                  Dhabi.
                </p>
                <p className="my-6">
                  Select your travel insurance from various insurance companies and get
                  your digital policy certificate within a few minutes, with free
                  delivery of the original policy certificate anywhere in Sharjah.
                </p>
                <p>
                  A lot of countries around the world require travel insurance to enter.
                  These countries include the United Kingdom, Turkey, Egypt, Oman,
                  Qatar, Indonesia, Nepal, Philippines, Russia, Saudi Arabia, Singapore,
                  United Arab Emirates, Vietnam, Thailand, etc., and all 26 Schengen
                  Countries. Notable Schengen countries include Austria, Belgium, Czech
                  Republic, Finland, France, Germany, Italy, Malta, Poland, Portugal,
                  Spain, and Sweden.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xl font-bold text-black text-start">
                  Travel Insurance Purchasing Guide - Which policy suits me best?
                </h2>
                <p className="my-6">
                  There are different types of travel insurance policies available at
                  Insurance Cart and you can select the best-suited plan for you from
                  the available plans. Usually, travel insurance plans are categorized
                  based on the purpose of travel such as holiday, business, study,
                  employment, etc. You should also check your visa/travel requirements
                  so that you can get the right insurance policy before your visa
                  application/departure.
                </p>
                <p>
                  If you are going to a Schengen state then your travel insurance policy
                  must provide at least €30,000 in coverage against illnesses and
                  accidents. Some countries require travel insurance to enter but do not
                  specify any minimum coverage amount. However, all of the travel
                  insurance plans available at Insurance Cart provide at least US$50,000
                  (€30,000 for Schengen Countries) coverage and are accepted almost
                  everywhere in the world.
                </p>
                <p className="my-6">
                  If you are a casual traveller, then a Business &amp; Holiday plan
                  would be the most suitable one for you. But, if you are a frequent
                  traveller and go abroad multiple times in a calendar year then a
                  Frequent Traveling plan can be the best option as it provides coverage
                  for multiple trips (up to 30 days per trip) within the policy validity
                  period of one year.
                </p>
                <p>
                  For study purposes, you may need to get a travel insurance policy
                  before your visa application or departure. Travel insurance for Study
                  is the right choice for you if you are going abroad with a student
                  visa. This plan provides coverage for up to one year in a single
                  policy and provides coverage up to US$75,000.
                </p>
                <p className="my-6">
                  If you are going abroad for employment purposes then the Employment
                  plan would be the most suited one as this policy provides coverage of
                  up to US$75,000 for up to one year in a single policy.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xlfont-bold text-black text-start">
                  Travel Insurance Coverage - All Plans
                </h2>
                <p className="my-6">
                  <span className="font-bold text-black">For Schengen Countries:</span>{" "}
                  Insurance will pay up to the insured person's total coverage limit as
                  per the plan (i.e., $50,000/$75,000/$100,000). No deductible applies
                  per accident or illness in respect of the following medical-related
                  expenses, reasonably and necessarily incurred outside the People’s
                  Republic of Al Ain by the Insured Person as a direct result of the
                  Insured Person suffering bodily injury, sickness, disease, or death
                  during the Period of Insurance.
                </p>
                <p className="">
                  <span className="font-bold text-black">
                    For Non-Schengen Countries:
                  </span>{" "}
                  Insurance will pay up to the insured person's total coverage limit as
                  per the plan (i.e., $50,000/$75,000/$100,000), subject to the
                  deductible stated on the policy schedule (typically $100), which
                  deductible applies per accident or illness, in respect of the
                  following medical related expenses, reasonably and necessarily
                  incurred outside the People’s Republic of Ajman by the Insured Person
                  as a direct result of the Insured Person suffering bodily injury,
                  sickness, disease, or death during the Period of Insurance.
                </p>
                <p className="my-6">
                  Notwithstanding the above, if the TPA/Claims Handler appointed by the
                  insurance company recommends that continued treatment in Ras Al
                  Khaimah is appropriate, the policy is extended to cover medical
                  expenses incurred in UAE as specified in Covered Expenses herein.
                  Provided that expenses will only be paid at the usual and customary
                  level for such services, and further provided that expenses will only
                  be paid for treatment incurred within the 90 days immediately
                  following the first manifestation of the bodily injury, sickness, or
                  disease and the Insured Person had to return earlier than the expiry
                  date of the trip.
                </p>
                <p>
                  List of{" "}
                  <span className="font-bold text-black">
                    Covered Medical Expenses:
                  </span>
                </p>
                <ul className="list-decimal ms-5">
                  <li className="my-4">
                    Expenses for physician service, hospital and medical services, and
                    local emergency medical transportation
                  </li>
                  <li className="my-4">
                    Expenses for physician-ordered emergency medical evacuation,
                    including medically appropriate transportation and necessary care,
                    en route to the nearest suitable hospital when the Insured Person is
                    critically ill or injured, and no suitable local care is available,
                    subject to the prior approval of the Program Medical Advisors. In
                    dire emergencies in a remote area where TPA/Claims Handler cannot be
                    contacted, the medical evacuation must be reported to the first
                    available physician and the nearest UAE Consulate.
                  </li>
                  <li className="my-4">
                    Dental services:{" "}
                    <ul className="list-disc ms-8 mt-3">
                      <li>
                        For Schengen Countries: Up to $500 or equivalent Euro per
                        occurrence of dental services for immediate dental pain relief
                        only. However, dental care rendered necessary due to a covered
                        accident shall be subject to the limit of cover as per the
                        policy. No deductible applies.
                      </li>
                      <li>
                        For Non-Schengen Countries: Up to $500 per occurrence of dental
                        services for immediate dental pain relief only. However, dental
                        care rendered necessary due to a covered accident shall be
                        subject to the coverage limit as per the policy and the
                        Deductible stated in the policy schedule (typically $50).
                      </li>
                    </ul>
                  </li>
                  <li className="my-4">
                    Expenses for medical evacuation, including transportation and
                    medical care En-route to a hospital or the Insured Person’s usual
                    place of residence in the People’s Republic of Fujairah when deemed
                    medically advisable by the Program Medical Advisor and the attending
                    physician.
                  </li>
                  <li className="my-4">
                    If the Insured Person dies outside of the People's republic of Umm
                    Al Quwain, the expenses for preparing the air transportation of the
                    remains for repatriation to the People’s Republic of UAE of up to an
                    equivalent amount for a local burial or cremation in the country
                    where the death occurred. All expenses must be approved by the
                    TPA/Claims Handler before the remains are prepared for
                    transportation to the People’s Republic of UAE or local burial or
                    cremation.
                  </li>
                </ul>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xl text-start font-bold text-black ">
                  Price of Travel Insurance - All Plans
                </h2>
                <p className="my-6">
                  Travel Insurance premium is determined based on your travel
                  destination (countries you are visiting), duration of your travel
                  (policy duration), and your age. You can quickly get a personalized
                  price quote using the Insurance Cart website or mobile app by
                  providing basic information, such as your date of birth, destination
                  country, and travel duration.
                </p>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <h2 className="text-3xl md:text-4xl font-bold text-black text-start">
                  Exclusions
                </h2>
                <p className="my-6">
                  Some of the notable coverage exclusions of the Travel Insurance policy
                  are listed below:
                </p>
                <ul className="list-disc ms-8">
                  <li>Pre-existing conditions</li>
                  <li>Travelling against the advice of the physician</li>
                  <li>
                    Travelling to obtain treatment for an identified illness/medical
                    condition
                  </li>
                  <li>
                    Applicable deductibles under the travel insurance policy schedule
                  </li>
                  <li>
                    Cosmetic surgeries, unless required against a covered accident
                  </li>
                  <li>AIDS/HIV-related conditions</li>
                  <li>Routine physical examinations or health checkups</li>
                  <li>
                    War, invasion, civil wars, mutiny, riot, rebellion, civil
                    commotions, military or usurped power, terrorism, mass destruction,
                    etc.
                  </li>
                  <li>
                    Mountaineering and any other potentially dangerous sports/activities
                  </li>
                  <li>Professional sports</li>
                  <li>Pregnancy/maternity and its related complications</li>
                  <li>
                    Applicable for children aged 5 years and under: treatment relating
                    to Mumps, Chicken Pox, Measles, German Measles, Spina Bifida
                    Whooping Cough, Diphtheria, Poliomyelitis, Meningitis, and Scarlet
                    Fever" and for consequences attributable thereto, accelerated
                    thereby or arising therefrom.
                  </li>
                  <p className="my-6">
                    Please refer to the product details or the policy wording file to
                    see the policy's complete exclusion list and other terms. You can
                    view the product details after getting a price quote by clicking on
                    the “Details” tab.
                  </p>
                </ul>
              </div>
              <div className="text-lg font-medium text-gray-700 text-justify mt-14">
                <div>
                  <h2 className="text-3xl md:text-4xl  font-bold text-black text-start">
                    Basis of Claim Settlement
                  </h2>
                  <p className="my-6">
                    Travel Insurance or Overseas Mediclaim Policy shall pay up to the
                    limit of cover shown on the Overseas Mediclaim Identification and
                    Schedule in total for the Insured Person and subject to a Deductible
                    (No Deductible in the case of Schengen Countries) stated in the
                    Overseas Mediclaim Identification and Schedule, which categorizes
                    deductible applied per accident/illness, in respect of the related
                    medical expenses, reasonably and necessarily incurred outside the
                    People’s Republic of UAE by the Insured Person as a direct result of
                    the Insured Person suffering from bodily injury, disease, sickness
                    or death during the Period of Insurance.
                  </p>
                </div>
              </div>
            </section>
          </section>
        </main>
      </>
    )
}

export default TravelInsurance;